import api from './_api';

const fetchFlags = () => api.get('/feature-flags/configs/');

export { fetchFlags };
